/** @format */
import { useTranslation } from 'next-i18next';

import {
    SecondaryCredit,
    UseSecondaryCreditParameters,
    UseSecondaryCreditReturn,
} from './config/types';
import { getTimestamp } from './get-timestamp';

export type {
    SecondaryCredit,
    UseSecondaryCreditParameters,
    UseSecondaryCreditReturn,
};

export const useSecondaryCredit = (): UseSecondaryCreditReturn => {
    const { t } = useTranslation();

    const getSecondaryCredit = ({
        editor,
        editedAt,
        translator,
        translatedAt,
    }: UseSecondaryCreditParameters): SecondaryCredit => {
        const isTranslatorLatest =
            !editor || getTimestamp(translatedAt) > getTimestamp(editedAt);

        if (translator && isTranslatorLatest) {
            return {
                person: translator,
                date: translatedAt,
                getText: (name) =>
                    t('Translated by <author-link>{{author}}</author-link>', {
                        author: name,
                    }),
            };
        }

        if (editor) {
            return {
                person: editor,
                date: editedAt,
                getText: (name) =>
                    t('Verified by <author-link>{{author}}</author-link>', {
                        author: name,
                    }),
            };
        }

        return null;
    };

    return { getSecondaryCredit };
};
